var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesLetters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2 4.6C2 4.26863 2.26863 4 2.6 4H4.62918C4.85644 4 5.0642 4.1284 5.16584 4.33167L6.33416 6.66833C6.4358 6.8716 6.64356 7 6.87082 7H12.8556C13.2038 7 13.4789 7.29543 13.4541 7.64275L13.0398 13.4427C13.0174 13.7567 12.7561 14 12.4413 14H2.6C2.26863 14 2 13.7314 2 13.4V4.6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7 2.5H12C12.2761 2.5 12.5 2.72386 12.5 3V10.8184C12.4999 11.0944 12.2761 11.3184 12 11.3184H7C6.72392 11.3184 6.5001 11.0944 6.5 10.8184V3C6.5 2.72386 6.72386 2.5 7 2.5Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92641 7.51515C2.96863 7.21956 3.22179 7 3.52038 7H13.3082C13.6733 7 13.9538 7.32339 13.9022 7.68485L13.0736 13.4849C13.0314 13.7804 12.7782 14 12.4796 14H2.69181C2.32668 14 2.0462 13.6766 2.09784 13.3151L2.92641 7.51515Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8 4.5H11",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8 7H11",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesLetters);
export default __webpack_public_path__ + "static/media/files-letters.644da9f35cf979af60e5070df88d0832.svg";
export { ForwardRef as ReactComponent };